import { z } from 'zod';

/** `returnTo` must be a relative path: starts with `/`, not `//` (no open redirects). */
export const DEFAULT_RETURN_TO = '/learn';

export function safeReturnTo(value: unknown): string {
  if (typeof value !== 'string' || value.length > 512) return DEFAULT_RETURN_TO;
  if (!value.startsWith('/') || value.startsWith('//') || value.startsWith('/\\')) return DEFAULT_RETURN_TO;
  if (value.includes('\\') || [...value].some((c) => c.charCodeAt(0) < 0x20)) return DEFAULT_RETURN_TO;
  return value;
}

export const EmailSchema = z
  .string()
  .trim()
  .toLowerCase()
  .max(254)
  .pipe(z.email('Enter a valid email address'));

export const MagicLinkRequestSchema = z.strictObject({
  email: EmailSchema,
  returnTo: z.string().max(512).optional(),
});
export type MagicLinkRequest = z.infer<typeof MagicLinkRequestSchema>;

export const ReturnToQuerySchema = z.strictObject({
  returnTo: z.string().max(512).optional(),
});

export const GithubCallbackQuerySchema = z.object({
  code: z.string().max(512).optional(),
  state: z.string().max(512).optional(),
  error: z.string().max(200).optional(),
});

export const MagicLinkVerifyQuerySchema = z.object({
  token: z.string().max(512).optional(),
});
